import { defineMessage } from 'services/localization';

export const messages = {
    payTitle: defineMessage('the_smarter_faster_safer_way_to_pay_your_bills'),
    captureTitle: defineMessage('automate_tedious_tasks'),
    payListItem1: defineMessage('make_payments_directly_in_approvalmax'),
    payListItem2: defineMessage('track_invoices_and_payments_in_realtime'),
    payListItem3: defineMessage('route_payments_accurately_every_time'),
    payListItem4: defineMessage('automate_reconciliation_tasks'),
    payListItem5: defineMessage('connect_to_your_bank_securely_using_open_banking'),
    captureListItem1: defineMessage('upload_single_or_bulk_bills_from_pdfs_or_images'),
    captureListItem2: defineMessage('extract_unlimited_line_items_at_no_extra_cost'),
    captureListItem3: defineMessage('email_documents_directl_x_via_a_dedicated_inbox'),
    captureListItem4: defineMessage('supports_languages'),
    captureListItem5: defineMessage('track_approvers_timesta_ger_for_audit_readiness'),
    chooseOrganisation: defineMessage('choose_organisation'),
    tryNowPayButtonText: defineMessage('try_now_payments_for_free'),
    tryNowCaptureButtonText: defineMessage('try_now_documents_for_free_for_days'),
    notifyAdminsButtonText: defineMessage('notify_admins_about_free_allfeature_trial'),
    contactSupportButtonText: defineMessage('contact_support_to_reset_all_features_trial'),
    learnMorePay: defineMessage('learn_more_about_approvalmax_pay'),
    learnMoreCapture: defineMessage('learn_more_about_approvalmax_capture'),
    videoTitle: defineMessage('youtube_video_player'),
    redirectWorkflowPageMessage: defineMessage('add_yourself_to_request_and_update_the_workflow'),
    redirectNewRequestPageMessage: defineMessage('upload_the_bill_file_to_eck_the_recognized_bill'),
};
